import { render, staticRenderFns } from "./ConfirmPromotionView.vue?vue&type=template&id=6d36b252"
import script from "./ConfirmPromotionView.vue?vue&type=script&lang=ts"
export * from "./ConfirmPromotionView.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPromotionView.vue?vue&type=style&index=0&id=6d36b252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports